// export const account_id = "7376";
// export const auth_key = "l875pnzp73vwlkyd";
// export const domain_key = "sandbox_product03";
// export const catalog_views = "sandbox_product03";
export const account_id = "6413";
export const auth_key = "bcvpynhij980k0y1";
export const domain_key = "pacifichome";
export const catalog_views = "pacifichome";
export const account_name = "PacificHome";
